// @ts-nocheck
import { useMemo, useState } from "react";
import styled from "styled-components";
import colors from "../../../styles/colors";

const Container = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
`;

const ModalDialog = styled.div`
    position: relative;
    width: 100%;
    max-width: 600px;
    margin: 28px auto;
    pointer-events: none;
`;

const ModalContent = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    pointer-events: auto;
    background-color: ${colors.bgColorBlack2};
    color: white;
    background-clip: padding-box;
    border: 5px solid gold;
    border-radius: 5px;
    outline: 0;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
`;

const ModalHeader = styled.div`
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    padding: 16px;
    border-bottom: 1px solid #dee2e6;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    gap: 12px;
`;

const ModalHeaderTop = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;

const ModalTitle = styled.h5`
    margin: 0;
    line-height: 1.5;
    font-size: 20px;
    font-weight: 500;
    color: gold;
`;

const CloseButton = styled.button`
    box-sizing: content-box;
    width: 1em;
    height: 1em;
    padding: 4px;
    color: white;
    border: 0;
    border-radius: 4px;
    opacity: 0.5;
    background: transparent;
    cursor: pointer;
    font-size: 24px;
    font-weight: 700;
    line-height: 1;
    text-shadow: 0 1px 0 #fff;
    
    &:hover {
        opacity: 0.75;
    }
    
    &:before {
        content: "×";
    }
`;

const ModalBody = styled.div`
    position: relative;
    flex: 1 1 auto;
    padding: 16px;
`;

const ModalFooter = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-shrink: 0;
    align-items: center;
    justify-content: flex-end;
    padding: 12px;
    border-top: 1px solid #dee2e6;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    gap: 8px;
`;

const FormGroup = styled.div`
    margin-bottom: 16px;
`;

const FormLabel = styled.label`
    display: inline-block;
    margin-bottom: 8px;
    font-weight: 500;
    color: gold;
`;

const FormInput = styled.input`
    display: block;
    width: 100%;
    padding: 6px 12px;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    color: #000000;
    background-color: #ffffff;
    background-image: none;
    border: 1px solid #d3d3d3;
    border-radius: 4px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    
    &:focus {
        color: #000000;
        background-color: #ffffff;
        border-color: #86b7fe;
        outline: 0;
        box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.25);
    }
`;

const FormSelect = styled.select`
    display: block;
    width: 100%;
    padding: 6px 12px;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    color: #000000;
    background-color: #ffffff;
    background-image: none;
    border: 1px solid #d3d3d3;
    border-radius: 4px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    
    &:focus {
        color: #000000;
        background-color: #ffffff;
        border-color: #86b7fe;
        outline: 0;
        box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.25);
    }
`;

const Button = styled.button`
    display: inline-block;
    font-weight: 400;
    line-height: 1.5;
    color: #ffffff;
    text-align: center;
    text-decoration: none;
    vertical-align: middle;
    cursor: pointer;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    padding: 6px 12px;
    font-size: 16px;
    border-radius: 4px;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    
    &:disabled {
        opacity: 0.65;
        cursor: not-allowed;
    }
`;

const ButtonPrimary = styled(Button)`
    color: white;
    background-color: #0d6efd;
    border-color: #0d6efd;
    
    &:hover:not(:disabled) {
        color: white;
        background-color: #0b5ed7;
        border-color: #0a58ca;
    }
`;

const ButtonSecondary = styled(Button)`
    color: #ffffff;
    background-color: #6c757d;
    border-color: #6c757d;
    
    &:hover:not(:disabled) {
        color: #ffffff;
        background-color: #5c636a;
        border-color: #565e64;
    }
`;

const ErrorText = styled.p`
    margin-top: 6px;
    margin-bottom: 0;
    color: #dc3545;
    font-size: 14px;
`;

function CreateTypeMatchModale({ closeModalClick, typeMatchTypes = [], onSave }) {
    const [selectedTypeMatchType, setSelectedTypeMatchType] = useState("");
    const [name, setName] = useState("");
    const [numTeams, setNumTeams] = useState("");
    const [minNumWrestlers, setMinNumWrestlers] = useState("");
    const [maxNumWrestlers, setMaxNumWrestlers] = useState("");
    const [errors, setErrors] = useState({});
    const [isSaving, setIsSaving] = useState(false);

    const options = useMemo(() => {
        const safe = Array.isArray(typeMatchTypes) ? typeMatchTypes : [];
        return [...safe]
            .filter((x: any) => x && (typeof x === "object" || typeof x === "string"))
            .map((x: any) => {
                if (typeof x === "string") {
                    return { correct_key_name: x, translate_key_name: x };
                }
                return x;
            })
            .filter((x: any) => x.correct_key_name)
            .sort((a, b) =>
                String(a.translate_key_name || a.correct_key_name).localeCompare(
                    String(b.translate_key_name || b.correct_key_name),
                    "it"
                )
            );
    }, [typeMatchTypes]);

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        setErrors({});

        const nextErrors = {};
        if (!selectedTypeMatchType) nextErrors.type_match_type = "Seleziona un tipo match";
        if (!name || name.trim().length === 0) nextErrors.name = "Inserisci un nome";

        const toInt = (v: any) => {
            if (v === null || v === undefined || String(v).trim() === "") return NaN;
            const n = parseInt(String(v), 10);
            return Number.isNaN(n) ? NaN : n;
        };

        const numTeamsInt = toInt(numTeams);
        const minInt = toInt(minNumWrestlers);
        const maxInt = toInt(maxNumWrestlers);

        if (Number.isNaN(numTeamsInt) || numTeamsInt < 1) nextErrors.num_teams = "Inserisci un numero teams valido (>= 1)";
        if (Number.isNaN(minInt) || minInt < 1) nextErrors.min_num_wrestler = "Inserisci un minimo valido (>= 1)";
        if (Number.isNaN(maxInt) || maxInt < 1) nextErrors.max_num_wrestlers = "Inserisci un massimo valido (>= 1)";
        if (!Number.isNaN(minInt) && !Number.isNaN(maxInt) && minInt > maxInt) nextErrors.max_num_wrestlers = "Il massimo deve essere >= del minimo";

        if (Object.keys(nextErrors).length > 0) {
            setErrors(nextErrors);
            return;
        }

        const payload = {
            type_match_type: selectedTypeMatchType,
            name: name.trim(),
            num_teams: numTeamsInt,
            min_num_wrestler: minInt,
            max_num_wrestlers: maxInt
        };

        setIsSaving(true);
        try {
            if (onSave) {
                await onSave(payload);
            } else {
                // endpoint di salvataggio lo colleghiamo quando definito
                console.log("Salvataggio TypeMatch (placeholder):", payload);
            }
            closeModalClick();
        } catch (error) {
            console.error("Errore durante il salvataggio:", error);
            setErrors({ general: error?.message || "Errore durante il salvataggio. Riprova." });
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Container className="create-type-match-modale-container">
            <ModalDialog className="create-type-match-modale-dialog">
                <ModalContent className="create-type-match-modale-content">
                    <form onSubmit={handleSubmit} className="create-type-match-modale-form">
                        <ModalHeader className="create-type-match-modale-header">
                            <ModalHeaderTop className="create-type-match-modale-header-top">
                                <ModalTitle className="create-type-match-modale-title">
                                    Aggiungi Type Match
                                </ModalTitle>
                                <CloseButton
                                    type="button"
                                    aria-label="Close"
                                    onClick={closeModalClick}
                                    className="create-type-match-modale-close-button"
                                />
                            </ModalHeaderTop>
                        </ModalHeader>
                        <ModalBody className="create-type-match-modale-body">
                            <FormGroup className="create-type-match-modale-form-group">
                                <FormLabel htmlFor="type_match_type" className="create-type-match-modale-label">
                                    Tipo match *
                                </FormLabel>
                                <FormSelect
                                    id="type_match_type"
                                    value={selectedTypeMatchType}
                                    onChange={(e: any) => setSelectedTypeMatchType(e.target.value)}
                                    className="create-type-match-modale-select"
                                >
                                    <option value="">Seleziona tipo match</option>
                                    {options.map((t: any) => (
                                        <option key={t.correct_key_name} value={t.correct_key_name}>
                                            {t.translate_key_name || t.correct_key_name}
                                        </option>
                                    ))}
                                </FormSelect>
                                {errors.type_match_type && (
                                    <ErrorText className="create-type-match-modale-error-text">
                                        {errors.type_match_type}
                                    </ErrorText>
                                )}
                            </FormGroup>

                            <FormGroup className="create-type-match-modale-form-group">
                                <FormLabel htmlFor="name" className="create-type-match-modale-label">
                                    Nome *
                                </FormLabel>
                                <FormInput
                                    id="name"
                                    type="text"
                                    value={name}
                                    onChange={(e: any) => setName(e.target.value)}
                                    placeholder="Inserisci nome..."
                                    className="create-type-match-modale-input"
                                />
                                {errors.name && (
                                    <ErrorText className="create-type-match-modale-error-text">
                                        {errors.name}
                                    </ErrorText>
                                )}
                            </FormGroup>

                            <FormGroup className="create-type-match-modale-form-group">
                                <FormLabel htmlFor="num_teams" className="create-type-match-modale-label">
                                    Numero Teams *
                                </FormLabel>
                                <FormInput
                                    id="num_teams"
                                    type="number"
                                    min="1"
                                    value={numTeams}
                                    onChange={(e: any) => setNumTeams(e.target.value)}
                                    placeholder="Es: 2"
                                    className="create-type-match-modale-input"
                                />
                                {errors.num_teams && (
                                    <ErrorText className="create-type-match-modale-error-text">
                                        {errors.num_teams}
                                    </ErrorText>
                                )}
                            </FormGroup>

                            <FormGroup className="create-type-match-modale-form-group">
                                <FormLabel htmlFor="min_num_wrestler" className="create-type-match-modale-label">
                                    Minimo Numero Wrestler per team *
                                </FormLabel>
                                <FormInput
                                    id="min_num_wrestler"
                                    type="number"
                                    min="1"
                                    value={minNumWrestlers}
                                    onChange={(e: any) => setMinNumWrestlers(e.target.value)}
                                    placeholder="Es: 1"
                                    className="create-type-match-modale-input"
                                />
                                {errors.min_num_wrestler && (
                                    <ErrorText className="create-type-match-modale-error-text">
                                        {errors.min_num_wrestler}
                                    </ErrorText>
                                )}
                            </FormGroup>

                            <FormGroup className="create-type-match-modale-form-group">
                                <FormLabel htmlFor="max_num_wrestlers" className="create-type-match-modale-label">
                                    Massimo Numero Wrestler per team *
                                </FormLabel>
                                <FormInput
                                    id="max_num_wrestlers"
                                    type="number"
                                    min="1"
                                    value={maxNumWrestlers}
                                    onChange={(e: any) => setMaxNumWrestlers(e.target.value)}
                                    placeholder="Es: 2"
                                    className="create-type-match-modale-input"
                                />
                                {errors.max_num_wrestlers && (
                                    <ErrorText className="create-type-match-modale-error-text">
                                        {errors.max_num_wrestlers}
                                    </ErrorText>
                                )}
                            </FormGroup>

                            {errors.general && (
                                <ErrorText className="create-type-match-modale-error-text">
                                    {errors.general}
                                </ErrorText>
                            )}
                        </ModalBody>
                        <ModalFooter className="create-type-match-modale-footer">
                            <ButtonSecondary
                                type="button"
                                onClick={closeModalClick}
                                className="create-type-match-modale-button-secondary"
                                disabled={isSaving}
                            >
                                Chiudi
                            </ButtonSecondary>
                            <ButtonPrimary
                                type="submit"
                                className="create-type-match-modale-button-primary"
                                disabled={isSaving}
                            >
                                {isSaving ? "Salvataggio..." : "Salva"}
                            </ButtonPrimary>
                        </ModalFooter>
                    </form>
                </ModalContent>
            </ModalDialog>
        </Container>
    );
}

export default CreateTypeMatchModale;

